<template>
  <section class="team">
    <div class="blex w-full pt-0 bg-black">

      <div class="blex bg-black w-full mb-40 lg:mb-120">
        <div class="text-white font-bold text-2xl lg:text-6xl blex pt-10 bottom-gradient pb-12">
          TEAM
        </div>
      </div>

      <div class="blex items-start bg-black px-16 w-full lg:w-3/4">
        <profile
            v-for="(team, index) in teams"
            :key="index"
            v-model="teams[index]"
        />
      </div>

    </div>

  </section>


</template>

<script>
import Profile from '@/views/components/team/profile'

export default {
  name: 'Team',
  data: () => ({
    teams: [
      {
        position: 'CEO',
        name: 'WONIK YI'
      },
      {
        position: 'CTO',
        name: 'EDWARD YI'
      },
      {
        position: 'HEAD OF USA',
        name: 'ALI BROWN'
      },
      {
        position: 'Sofrware Architect',
        name: 'VICTOR KIM'
      },
      {
        position: 'Fronted Developer',
        name: 'J. J. KIM'
      },
      {
        position: 'Backend Developer',
        name: 'JUN YI'
      },
      {
        position: 'Cheif Operating Officer',
        name: 'SEA HOON CHOI'
      },
      {
        position: 'Business Developer',
        name: 'ALEX KIM'
      }
    ]

  }),
  components: {Profile}
}
</script>

<style scoped lang="scss">
section::v-deep {
}

</style>
